"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiButton = getMuiButton;
exports.getMuiButtonBase = getMuiButtonBase;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _constants = require("../../../constants");
/* eslint-disable max-lines */

function getMuiButtonBase() {
  return {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true,
      focusRipple: false
    }
  };
}
function getMuiButton() {
  return {
    defaultProps: {
      disableElevation: true,
      variant: 'primary'
    },
    styleOverrides: {
      root: {
        '&.loading, &.loading-iconOnly': {
          pointerEvents: 'none'
        },
        '.MuiButton-endIcon': {
          marginRight: '0px !important'
        },
        '.MuiButton-startIcon': {
          marginLeft: '0px !important'
        },
        boxSizing: 'border-box'
      }
    },
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        '& .MuiSvgIcon-root': {
          height: '20px',
          width: '20px'
        },
        '& .zenith-icon': {
          height: '20px',
          width: '20px'
        },
        '&.loading-iconOnly': {
          padding: '8px'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            padding: '8px 14px'
          },
          '&:has(.MuiButton-startIcon)': {
            padding: '8px 14px'
          },
          padding: '8px'
        },
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '20px',
        padding: '8px 14px'
      }
    }, {
      props: {
        size: 'medium'
      },
      style: {
        '& .MuiSvgIcon-root, .zenith-icon': {
          height: '20px',
          width: '20px'
        },
        '&.loading-iconOnly': {
          padding: '10px'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            padding: '10px 16px'
          },
          '&:has(.MuiButton-startIcon)': {
            padding: '10px 16px'
          },
          padding: '10px'
        },
        border: 0,
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '20px',
        padding: '10px 16px'
      }
    }, {
      props: {
        size: 'large'
      },
      style: {
        '& .MuiSvgIcon-root, .zenith-icon': {
          height: '20px',
          width: '20px'
        },
        '&.loading-iconOnly': {
          padding: '12px'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            padding: '10px 18px'
          },
          '&:has(.MuiButton-startIcon)': {
            padding: '10px 18px'
          },
          padding: '12px'
        },
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        padding: '10px 18px'
      }
    }, {
      props: {
        size: 'xl'
      },
      style: {
        '& .MuiSvgIcon-root, .zenith-icon': {
          height: '20px',
          width: '20px'
        },
        '&.loading-iconOnly': {
          padding: '14px'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            padding: '12px 20px'
          },
          '&:has(.MuiButton-startIcon)': {
            padding: '12px 20px'
          },
          padding: '14px'
        },
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        padding: '12px 20px'
      }
    }, {
      props: {
        size: 'xxl'
      },
      style: {
        '& .MuiButton-endIcon': {
          marginLeft: '12px'
        },
        '& .MuiButton-startIcon': {
          marginRight: '12px'
        },
        '& .MuiSvgIcon-root': {
          height: '24px',
          width: '24px'
        },
        '& .zenith-icon': {
          height: '28px',
          width: '28px'
        },
        '&.loading-iconOnly': {
          padding: '20px'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            padding: '16px 28px'
          },
          '&:has(.MuiButton-startIcon)': {
            padding: '16px 28px'
          },
          padding: '16px'
        },
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '28px',
        padding: '16px 28px'
      }
    }, {
      props: {
        variant: 'primary'
      },
      style: function (_ref) {
        var theme = _ref.theme;
        return {
          '&.Mui-disabled': {
            background: theme.palette.primary[200],
            color: theme.palette.common.white,
            outlineColor: theme.palette.primary[200]
          },
          '&.loading, &.loading-iconOnly': {
            background: theme.palette.primary[200],
            color: theme.palette.common.white,
            outlineColor: theme.palette.primary[200]
          },
          '&:focus-visible': {
            boxShadow: "0 0 0 4px ".concat(theme.palette.primary[100])
          },
          '&:hover': {
            background: theme.palette.primary[700],
            outlineColor: theme.palette.primary[700]
          },
          background: theme.palette.primary[600],
          borderRadius: '32px',
          boxShadow: theme.shadows[_constants.SHADOWS.xs],
          color: theme.palette.common.white,
          height: 'fit-content',
          minWidth: 'fit-content',
          outline: "1px solid ".concat(theme.palette.primary[600]),
          outlineOffset: -1,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'primary-destructive'
      },
      style: function (_ref2) {
        var theme = _ref2.theme;
        return {
          '&.Mui-disabled': {
            background: theme.palette.error[200],
            color: theme.palette.common.white,
            outlineColor: theme.palette.error[200]
          },
          '&.loading, &.loading-iconOnly': {
            background: theme.palette.error[200],
            color: theme.palette.common.white,
            outlineColor: theme.palette.error[200]
          },
          '&:focus-visible': {
            boxShadow: "0 0 0 4px ".concat(theme.palette.error[100])
          },
          '&:hover': {
            background: theme.palette.error[700],
            outlineColor: theme.palette.error[700]
          },
          background: theme.palette.error[600],
          borderRadius: '32px',
          boxShadow: theme.shadows[_constants.SHADOWS.xs],
          color: theme.palette.common.white,
          height: 'fit-content',
          minWidth: 'fit-content',
          outline: "1px solid ".concat(theme.palette.error[600]),
          outlineOffset: -1,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'secondary'
      },
      style: function (_ref3) {
        var theme = _ref3.theme;
        return {
          '&.Mui-disabled': {
            background: theme.palette.primary[25],
            color: theme.palette.primary[300],
            outlineColor: theme.palette.primary[25]
          },
          '&.loading, &.loading-iconOnly': {
            background: theme.palette.primary[25],
            color: theme.palette.primary[300],
            outlineColor: theme.palette.primary[25]
          },
          '&:focus-visible': {
            background: theme.palette.primary[50],
            boxShadow: "0 0 0 4px ".concat(theme.palette.primary[100])
          },
          '&:hover': {
            background: theme.palette.primary[100],
            color: theme.palette.primary[800]
          },
          background: theme.palette.common.white,
          borderRadius: '32px',
          boxShadow: theme.shadows[_constants.SHADOWS.xs],
          color: theme.palette.primary[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          outline: "1px solid ".concat(theme.palette.primary[200]),
          outlineOffset: -1,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'secondary-destructive'
      },
      style: function (_ref4) {
        var theme = _ref4.theme;
        return {
          '&.Mui-disabled': {
            background: theme.palette.error[25],
            color: theme.palette.error[300],
            outlineColor: theme.palette.error[25]
          },
          '&.loading, &.loading-iconOnly': {
            background: theme.palette.error[25],
            color: theme.palette.error[300],
            outlineColor: theme.palette.error[25]
          },
          '&:focus-visible': {
            background: theme.palette.error[50],
            boxShadow: "0 0 0 4px ".concat(theme.palette.error[100])
          },
          '&:hover': {
            background: theme.palette.error[100],
            color: theme.palette.error[800]
          },
          background: theme.palette.error[50],
          borderRadius: '32px',
          boxShadow: theme.shadows[_constants.SHADOWS.xs],
          color: theme.palette.error[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          outline: "1px solid ".concat(theme.palette.error[200]),
          outlineOffset: -1,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'secondary-gray'
      },
      style: function (_ref5) {
        var theme = _ref5.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.gray[300],
            outlineColor: theme.palette.gray[200]
          },
          '&.loading, &.loading-iconOnly': {
            background: theme.palette.common.white,
            color: theme.palette.gray[300],
            outlineColor: theme.palette.gray[200]
          },
          '&:focus-visible': {
            boxShadow: "0 0 0 4px ".concat(theme.palette.gray[100])
          },
          '&:hover': {
            background: theme.palette.gray[100],
            color: theme.palette.gray[800]
          },
          background: theme.palette.common.white,
          borderRadius: '32px',
          boxShadow: theme.shadows[_constants.SHADOWS.xs],
          color: theme.palette.gray[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          outline: "1px solid ".concat(theme.palette.gray[400]),
          outlineOffset: -1,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'secondary-gray-destructive'
      },
      style: function (_ref6) {
        var theme = _ref6.theme;
        return {
          '&.Mui-disabled': {
            background: theme.palette.common.white,
            color: theme.palette.error[300],
            outlineColor: theme.palette.error[200]
          },
          '&.loading, &.loading-iconOnly': {
            background: theme.palette.common.white,
            color: theme.palette.error[300],
            outlineColor: theme.palette.error[200]
          },
          '&:focus-visible': {
            background: theme.palette.common.white,
            boxShadow: "0 0 0 4px ".concat(theme.palette.error[100])
          },
          '&:hover': {
            background: theme.palette.error[100],
            color: theme.palette.error[800]
          },
          background: theme.palette.common.white,
          borderRadius: '32px',
          boxShadow: theme.shadows[_constants.SHADOWS.xs],
          color: theme.palette.error[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          outline: "1px solid ".concat(theme.palette.error[300]),
          outlineOffset: -1,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'tertiary-gray'
      },
      style: function (_ref7) {
        var theme = _ref7.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.gray[300]
          },
          '&:focus-visible': {
            background: theme.palette.gray[50],
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.gray[100])
          },
          '&:hover': {
            background: theme.palette.gray[100],
            color: theme.palette.gray[700]
          },
          borderRadius: '32px',
          color: theme.palette.gray[600],
          height: 'fit-content',
          minWidth: 'fit-content',
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'tertiary-gray-destructive'
      },
      style: function (_ref8) {
        var theme = _ref8.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.error[300]
          },
          '&:focus-visible': {
            background: theme.palette.error[25],
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.error[100])
          },
          '&:hover': {
            background: theme.palette.error[50],
            color: theme.palette.error[800]
          },
          borderRadius: '32px',
          color: theme.palette.error[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'tertiary'
      },
      style: function (_ref9) {
        var theme = _ref9.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.gray[300]
          },
          '&:focus-visible': {
            background: theme.palette.primary[25],
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100])
          },
          '&:hover': {
            background: theme.palette.primary[50],
            color: theme.palette.primary[800]
          },
          borderRadius: '32px',
          color: theme.palette.primary[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'tertiary-destructive'
      },
      style: function (_ref10) {
        var theme = _ref10.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.error[300]
          },
          '&:focus-visible': {
            background: theme.palette.error[25],
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.error[100])
          },
          '&:hover': {
            background: theme.palette.error[50],
            color: theme.palette.error[800]
          },
          borderRadius: '32px',
          color: theme.palette.error[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'link-gray'
      },
      style: function (_ref11) {
        var theme = _ref11.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.gray[300]
          },
          '&:focus-visible': {
            background: theme.palette.common.white,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.gray[100])
          },
          '&:has(.MuiSvgIcon-root)': {
            '&:has(.MuiButton-endIcon)': {
              padding: 0
            },
            '&:has(.MuiButton-startIcon)': {
              padding: 0
            },
            padding: 0
          },
          '&:hover': {
            background: 'none',
            color: theme.palette.gray[700]
          },
          borderRadius: '4px',
          color: theme.palette.gray[600],
          height: 'fit-content',
          minWidth: 'fit-content',
          padding: 0,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'link-gray-destructive'
      },
      style: function (_ref12) {
        var theme = _ref12.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.error[300]
          },
          '&:focus-visible': {
            background: theme.palette.common.white,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.error[100])
          },
          '&:has(.MuiSvgIcon-root)': {
            '&:has(.MuiButton-endIcon)': {
              padding: 0
            },
            '&:has(.MuiButton-startIcon)': {
              padding: 0
            },
            padding: 0
          },
          '&:hover': {
            background: 'none',
            color: theme.palette.error[800]
          },
          borderRadius: '4px',
          color: theme.palette.error[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          padding: 0,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'link'
      },
      style: function (_ref13) {
        var theme = _ref13.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.gray[300]
          },
          '&:focus-visible': {
            background: theme.palette.common.white,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100])
          },
          '&:has(.MuiSvgIcon-root)': {
            '&:has(.MuiButton-endIcon)': {
              padding: 0
            },
            '&:has(.MuiButton-startIcon)': {
              padding: 0
            },
            padding: 0
          },
          '&:hover': {
            background: 'none',
            color: theme.palette.primary[800]
          },
          borderRadius: '4px',
          color: theme.palette.primary[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          padding: 0,
          textTransform: 'none'
        };
      }
    }, {
      props: {
        variant: 'link-destructive'
      },
      style: function (_ref14) {
        var theme = _ref14.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.error[300]
          },
          '&:focus-visible': {
            background: theme.palette.common.white,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.error[100])
          },
          '&:has(.MuiSvgIcon-root)': {
            '&:has(.MuiButton-endIcon)': {
              padding: 0
            },
            '&:has(.MuiButton-startIcon)': {
              padding: 0
            },
            padding: 0
          },
          '&:hover': {
            background: 'none',
            color: theme.palette.error[800]
          },
          borderRadius: '4px',
          color: theme.palette.error[700],
          height: 'fit-content',
          minWidth: 'fit-content',
          padding: 0,
          textTransform: 'none'
        };
      }
    }].concat((0, _toConsumableArray2["default"])(getLinkVariantStyles()))
  };
}
var sizes = ['small', 'medium', 'large', 'xl', 'xxl'];
var linkVariants = ['link', 'link-destructive', 'link-gray', 'link-gray-destructive'];
var lineHeightMap = {
  large: '24px',
  medium: '20px',
  small: '20px',
  xl: '24px',
  xxl: '28px'
};
var getLinkVariantStyles = function getLinkVariantStyles() {
  var styles = [];
  for (var _i = 0, _sizes = sizes; _i < _sizes.length; _i++) {
    var size = _sizes[_i];
    for (var _i2 = 0, _linkVariants = linkVariants; _i2 < _linkVariants.length; _i2++) {
      var linkVariant = _linkVariants[_i2];
      styles.push({
        props: {
          size: size,
          variant: linkVariant
        },
        style: {
          lineHeight: lineHeightMap[size],
          minHeight: '22px'
        }
      });
    }
  }
  return styles;
};